import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';

import { useNextPage } from '../../hooks/useNextPage';

export const ViewMoreSupporterVoices: React.FC = () => {
	const [{ isLastSupporterVoicesPage, isLoadingMoreSupporterVoices }] = usePetitionActionsPageState();
	const {
		actions: { nextPage },
	} = useNextPage();

	if (isLastSupporterVoicesPage) return null;

	return (
		<div className="text-center">
			<Button
				data-testid="view-more-supporter-voices"
				data-qa="view-more-supporter-voices"
				loading={isLoadingMoreSupporterVoices}
				variant="secondary"
				className="mt-2 w-full md:w-1/2"
				onClick={nextPage}
			>
				<Translate value="corgi.petition_actions.supporter_voices_text_list.view_more_label" />
			</Button>
		</div>
	);
};
